export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10886.b6e72d04.jpg";